"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _ModalWrapper = _interopRequireDefault(require("../ModalWrapper"));

var _AlertModalBase = require("./AlertModalBase.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
* PLEASE NOTE: while this is named AlertModalBase, it is now used as a base for new style modals
*/
var AlertModalBase = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AlertModalBase, _React$PureComponent);

  var _super = _createSuper(AlertModalBase);

  function AlertModalBase() {
    var _this;

    _classCallCheck(this, AlertModalBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "buildSecondaryText", function () {
      var secondaryText = _this.props.secondaryText;

      if (!secondaryText) {
        return [];
      }

      var arrayifiedSecondaryText = (0, _lodash.castArray)(secondaryText);
      return arrayifiedSecondaryText.map(function (text, index) {
        return /*#__PURE__*/_react.default.createElement(_AlertModalBase.StyledSecondaryText, {
          key: "secondary-text-block-".concat(index) // eslint-disable-line react/no-array-index-key
          ,
          dataTestId: "alert-choice-modal-paragraph-text-".concat(index)
        }, text);
      });
    });

    return _this;
  }

  _createClass(AlertModalBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _inStyleGuide = _this$props._inStyleGuide,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          modalRole = _this$props.modalRole,
          primaryText = _this$props.primaryText,
          title = _this$props.title;
      var renderedSecondaryText = this.buildSecondaryText();
      return /*#__PURE__*/_react.default.createElement(_ModalWrapper.default, {
        _inStyleGuide: _inStyleGuide,
        className: className,
        closeHandler: function closeHandler() {},
        dataTestId: "alert-choice-modal-modal-wrapper",
        isOpen: isOpen,
        modalRole: modalRole,
        title: title
      }, !!primaryText && /*#__PURE__*/_react.default.createElement(_AlertModalBase.StyledPrimaryText, {
        dataTestId: "alert-choice-modal-primary-text"
      }, primaryText), !!renderedSecondaryText.length && /*#__PURE__*/_react.default.createElement("div", null, renderedSecondaryText), children);
    }
  }]);

  return AlertModalBase;
}(_react.default.PureComponent);

_defineProperty(AlertModalBase, "propTypes", {
  /** Styleguide override */
  _inStyleGuide: _propTypes.default.bool,

  /** Child interactive elements */
  children: _propTypes.default.node.isRequired,

  /** Styling classname */
  className: _propTypes.default.string,

  /** Toggle for controlled open */
  isOpen: _propTypes.default.bool.isRequired,

  /** Type of model i.e. alert or info */
  modalRole: _propTypes.default.string,

  /** Text for bolded content text */
  primaryText: _propTypes.default.string,

  /** Text for secondary content text */
  secondaryText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),

  /** Text for modal header */
  title: _propTypes.default.string
});

_defineProperty(AlertModalBase, "defaultProps", {
  _inStyleGuide: _propTypes.default.false,
  className: '',
  modalRole: 'alert',
  primaryText: undefined,
  secondaryText: undefined,
  title: ''
});

var _default = AlertModalBase;
exports.default = _default;